import { useEffect, useState } from "react";
import { api, money, qtyLabel } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import StatusBadge from "@/components/StatusBadge";
import { PlusCircle } from "lucide-react";

export default function RFQList() {
  const { user } = useAuth();
  const [rfqs, setRfqs] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => { (async () => { const { data } = await api.get("/rfqs"); setRfqs(data); })(); }, []);

  const filtered = rfqs.filter((r) => !q || r.title.toLowerCase().includes(q.toLowerCase()) || r.reference?.toLowerCase().includes(q.toLowerCase()));

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <div className="eyebrow">Requests for Quotation</div>
          <h1 className="font-display text-3xl font-extrabold text-[#0A2540] tracking-tight mt-1">
            {user.role === "buyer" ? "My RFQs" : user.role === "supplier" ? "Invited RFQs" : "All RFQs"}
          </h1>
        </div>
        {user.role === "buyer" && (
          <Link to="/app/rfqs/new"><Button className="bg-[#0A2540] hover:bg-[#061A2E] gap-2" data-testid="new-rfq-btn"><PlusCircle className="w-4 h-4" /> New RFQ</Button></Link>
        )}
      </div>

      <Input placeholder="Search by title or reference…" value={q} onChange={(e) => setQ(e.target.value)} className="max-w-md" data-testid="rfq-search-input" />

      <Card className="border-slate-200 overflow-hidden">
        {filtered.length === 0 ? (
          <div className="p-10 text-center text-slate-500 text-sm">No RFQs found.</div>
        ) : (
          <table className="w-full text-sm">
            <thead className="bg-slate-50 border-b border-slate-200">
              <tr className="text-left text-xs uppercase tracking-wider text-slate-500">
                <th className="px-6 py-3">Reference</th>
                <th className="px-6 py-3">Title</th>
                <th className="px-6 py-3">Category</th>
                <th className="px-6 py-3">Quantity</th>
                {user.role !== "buyer" && <th className="px-6 py-3">Buyer</th>}
                <th className="px-6 py-3">Budget</th>
                <th className="px-6 py-3">Status</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {filtered.map((r) => (
                <tr key={r.id} className="hover:bg-slate-50 cursor-pointer" onClick={() => (window.location.href = `/app/rfqs/${r.id}`)} data-testid={`rfq-list-row-${r.id}`}>
                  <td className="px-6 py-4 font-mono-num text-xs text-slate-600">{r.reference}</td>
                  <td className="px-6 py-4 font-medium text-[#0A2540]">{r.title}</td>
                  <td className="px-6 py-4 text-slate-600">{r.category}</td>
                  <td className="px-6 py-4 text-slate-700" data-testid={`rfq-qty-cell-${r.id}`}>{qtyLabel(r.quantity, r.uom || r.unit)}</td>
                  {user.role !== "buyer" && <td className="px-6 py-4 text-slate-600">{r.buyer?.company_name}</td>}
                  <td className="px-6 py-4 font-mono-num text-slate-700">{r.target_budget ? money(r.target_budget) : "—"}</td>
                  <td className="px-6 py-4"><StatusBadge status={r.status} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </Card>
    </div>
  );
}
